/* eslint-disable prettier/prettier */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Skeleton } from 'antd';
import { Button } from 'antd-v5';
import { Link } from 'react-router-dom';
import Axios from 'axios';
// import { getRequest } from '../../../../../../../core/apiRequests';
import { PAYMENTS_API_URL } from '../../../../constants';

const Payments = props => {
  const [loading, setLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [payments, setPayments] = useState([]);
  const clientId = props.messaging.client.client_id;


  useEffect(() => {
    if (props.merchantId && clientId) {
      Axios.get(
        `${PAYMENTS_API_URL}/v1/paymentRequest/getPaymentRequestByClientId?clientId=${clientId}`,
      )
        .then(response => {
          const newestPayments = response.data?.sort((a, b) => {
            return b.paymentId - a.paymentId;
          });
          setPayments(newestPayments.slice(0, 2));
        })
        .catch(err => {
          // Silently handle error - payments API may not be available
          console.warn('Payments API unavailable:', err.message);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [props.merchantId, clientId]);

  const PaymentData = () => {
    const returnArr = [];
    if (loading) {
      returnArr.push(
        <div key="skeleton">
          <Skeleton
            paragraph={{
              rows: 3,
            }}
            active
          />
        </div>,
      );
      return returnArr;
    }
    if (payments.length > 0) {
      payments.forEach(pay => {
        returnArr.push(
          <div className="m-btm-12" key={pay.paymentId}>
            <div className="paymentDivider" />
            <div className="flex-col-left m-top-8 fs-12 align-left">
              <span>{`Item: ${
                pay.productDescriptions.length > 0 ? pay.productDescriptions[0] : 'no description'
              }`}</span>
              <span>{`Amount: $${pay.amount}`}</span>
              <span>{`Status: ${pay.status}`}</span>
              <span>{`Payment ID: ${pay.paymentId}`}</span>
            </div>
          </div>,
        );
      });
      return returnArr;
    }
    return returnArr;
  };

  return (
    <div style={{ borderTop: '1px #ebebeb solid' }}>
      {PaymentData().length > 0 ? (
        <div>
          <p className="fw-500 gray fs-15 align-left m-btm-5">Payments</p>
          {PaymentData()}
          <Link to={`/Clients?client=${clientId}`}>
            <Button type="link" className="cb-link-btn">
              View All In Client Profile
            </Button>
          </Link>
        </div>
      ) : (
        <div className="m-top-8 ">
          <p className="fw-500 gray fs-15 align-left m-btm-5">Payments</p>
          <span className="gray fs-12">No Payment History</span>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  messaging: state.messaging,
});
export default connect(mapStateToProps)(Payments);
